import axios from 'axios';
import { getAuthHeader } from '../utils/authUtils';

const API = process.env.REACT_APP_API_URL;

/**
 * Persist tour progress: { seen: { pageKey: true|false }, skippedAll, remindAfter, reset }.
 * Fire-and-forget from the tour engine; the local copy is already updated.
 */
export async function saveTours(patch) {
  const { data } = await axios.put(`${API}/api/users/profile/tours`, patch, { headers: getAuthHeader() });
  return data.tours;
}

export const emptyTours = () => ({ seen: {}, skippedAll: false, remindAfter: null });

export const normalizeTours = (raw) => {
  const t = raw && typeof raw === 'object' ? raw : {};
  return {
    seen: t.seen && typeof t.seen === 'object' ? { ...t.seen } : {},
    skippedAll: !!t.skippedAll,
    remindAfter: t.remindAfter || null
  };
};
